var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "15px",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart_svg__heart_svg__Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart_svg__heart_svg__heart",
    fillRule: "nonzero",
    fill: "#FA3060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart_svg__heart_svg__Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart_svg__heart_svg__07-1-NeonBlue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart_svg__heart_svg__Group-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0540421,4.1897516 C16.2495978,-0.7713169 10.8053799,-1.1517375 8.9156519,3.4384775 C6.9091612,-1.1517374 1.5572956,-0.9384988 0.725417,4.1897516 C-0.1064617,9.318002 8.9156519,14.9736995 8.9156519,14.9736995 C8.9156519,14.9736995 17.8584865,9.15082 17.0540421,4.1897516 Z",
    id: "heart_svg__heart_svg__Health-icon"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.634ae3854bdf59409fddca897b7ffacb.svg";
export { ForwardRef as ReactComponent };